import React from 'react';
import styles from './LandingPage5.module.css';

// Placeholder icons – replace with your actual SVG imports or img tags
import RobotIcon from '../../../../Images/newLandingPage/51.png';
import CrmIcon from       '../../../../Images/newLandingPage/52.png';
import RoutingIcon from   '../../../../Images/newLandingPage/53.png';
import AnalyticsIcon from '../../../../Images/newLandingPage/54.png';
import LanguageIcon from  '../../../../Images/newLandingPage/55.png';

import crm from "../../../../Images/newLandingPage/5CRM.png";
const LandingPage5 = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Main Title */}
     

        {/* Features Grid */}
        <div className={styles.grid}>
             <h2 className={styles.title}>
          Powerful <br />
          Features That <br />
          <span className={styles.gradientText}>Drive Results</span>
        </h2>
          {/* Feature 1 */}
          <div className={styles.feature}>
            <div className={styles.iconCircle}>
              <div className={styles.number}>01</div>
              <img src={RobotIcon} alt="AI Call Automation" className={styles.featureIcon} />
            </div>
            <h3 className={styles.featureTitle}>AI Call Automation</h3>
            <p className={styles.featureDesc}>
              Natural-sounding AI handles inbound and outbound calls with human-like intelligence.
            </p>
          </div>

          {/* Feature 2 */}
          <div className={styles.feature}>
            <div className={styles.iconCircle}>
              <div className={styles.number}>02</div>
              <img src={CrmIcon} alt="Built-In CRM" className={styles.featureIcon} />
            </div>
            <h3 className={styles.featureTitle}>Built-In CRM</h3>
            <p className={styles.featureDesc}>
              All leads automatically organized with contact details and call history.
            </p>
          </div>

          {/* Feature 3 */}
          <div className={styles.feature}>
            <div className={styles.iconCircle}>
              <div className={styles.number}>03</div>
              <img src={RoutingIcon} alt="Smart Call Routing" className={styles.featureIcon} />
            </div>
            <h3 className={styles.featureTitle}>Smart Call Routing</h3>
            <p className={styles.featureDesc}>
              Intelligently route calls to AI, team members, or departments based on rules.
            </p>
          </div>

          {/* Feature 4 & 5 placed in second row visually via grid */}
          <div className={styles.feature}>
            <div className={styles.iconCircle}>
              <div className={styles.number}>04</div>
              <img src={AnalyticsIcon} alt="Real-Time Analytics" className={styles.featureIcon} />
            </div>
            <h3 className={styles.featureTitle}>Real-Time Analytics</h3>
            <p className={styles.featureDesc}>
              All leads automatically organized with contact details and call history.
            </p>
          </div>

          <div className={styles.feature}>
            <div className={styles.iconCircle}>
              <div className={styles.number}>05</div>
              <img src={LanguageIcon} alt="Multilanguage Support" className={styles.featureIcon} />
            </div>
            <h3 className={styles.featureTitle}>Multilanguage Support</h3>
            <p className={styles.featureDesc}>
              All leads automatically organized with contact details and call history.
            </p>
          </div>
        </div>

        {/* Integrations Section */}
        <div className={styles.integration}>
          <h2 className={styles.integrationTitle}>Works with Your Existing Tools</h2>
          <div className={styles.integrationContent}>
            <p className={styles.integrationDesc}>
            Seamlessly connects with major CRMs + business apps.
          </p>

          <div className={styles.integrationLogos}>
            <img src={crm} alt="Salesforce" className={styles.logo} />
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingPage5;